exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-contenteditable[data-v-c25655a4]{width:100%;word-break:break-word;cursor:text}.fts-contenteditable[data-v-c25655a4]:empty:before{content:attr(placeholder);-webkit-text-fill-color:inherit;opacity:.45}.fts-contenteditable.content-nowrap[data-v-c25655a4]{overflow:hidden;white-space:nowrap}.fts-contenteditable.content-wrap[data-v-c25655a4]{word-break:break-word}.fts-contenteditable.disabled[data-v-c25655a4]{cursor:default}", ""]);

// exports
